import { apiRequest } from "./client";

export const fiscalApi = {
  listDocuments(projectId, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") query.set(key, String(value));
    });
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return apiRequest(`/projects/${projectId}/fiscal/documents${suffix}`);
  },

  listCandidates(projectId, { limit = 50 } = {}) {
    return apiRequest(`/projects/${projectId}/fiscal/candidates?limit=${encodeURIComponent(limit)}`);
  },

  createFromMovement(projectId, movementId, recipient) {
    return apiRequest(`/projects/${projectId}/fiscal/movements/${movementId}`, {
      method: "POST",
      body: JSON.stringify({ recipient }),
    });
  },

  issue(projectId, documentId) {
    return apiRequest(`/projects/${projectId}/fiscal/documents/${documentId}/issue`, {
      method: "POST",
    });
  },

  retry(projectId, documentId) {
    return apiRequest(`/projects/${projectId}/fiscal/documents/${documentId}/retry`, {
      method: "POST",
    });
  },
};
